import get_param from '../param'
import isFunction from 'lodash/isFunction'
import {USERCENTER_TICKET, MSITE_HDCN} from '../../constant/CookieKeys'
import * as Cookie from 'tiny-cookie'
import {autoLogin} from './login'

export function url_without_ticket(url) {
  if (!url) {
    url = window.location.href;
  }
  return url.replace(/ticket=[^&#]*/g, '')
}

export function share_url(url) {
  let t = url_without_ticket(url);
  let res = t.replace(/source=[^&#]*/g, 'source=share_' + window.rootdata.act_name).replace(/code=[^&#]*/g, '');
  if (!res.includes('#')) {
    res = res + '#/'
  }
  console.log(res)
  return res
}


function get_h5_ticket(cb) {
  let ticket = null;
  const hdcn = Cookie.get(MSITE_HDCN, {domain: "mgtv.com"});
  if (hdcn) {
    ticket = hdcn.split("-")[0];
  }
  if(!ticket){
    ticket =  Cookie.get('ticket', {domain: "mgtv.com"});
  }
  if (!ticket) {
    ticket = get_param('ticket');
  }
  if(ticket){
    window.localStorage.setItem(USERCENTER_TICKET, ticket); //同步给原有用户中心的ticket
    if(!hdcn){
      Cookie.set(MSITE_HDCN, `${ticket}-1`, {domain: "mgtv.com"}); //同步给M站
    }
  }

  if ((!ticket) && gact.auto_login) {
    autoLogin(() => {
      cb(null);
    });
    return;
  }
  cb(ticket);
}

// function get_h5_ticket(cb) {
//   let ticket = null;
//   if (!gact.test_env) {
//     if (window.location.host === 'club.mgtv.com') {
//       ticket = window.localStorage.getItem('usercenter_t')
//
//
//     } else {
//       ticket = get_param('ticket')
//     }
//   } else {
//     ticket = get_param('ticket')
//   }
//   cb(ticket)
// }

function get_app_ticket(cb) {
  if (gact.debug) {
    get_h5_ticket(cb);
    return;
  } else {
    MgtvApi.getUserInfo(function (user_info) {
      if (user_info && user_info.length !== 0) {
        const ticket = (JSON.parse(user_info)).ticket;
        cb(ticket);
      } else {
        cb(null);//没有登录
      }
    })
  }

}


export function get_ticket(cb) {
  if (!isFunction(cb)) {
    console.error("not callback function in get_ticket")
    return;
  }
  if (gact.is_app) {
    get_app_ticket(cb)
  } else {
    get_h5_ticket(cb)
  }
}






// WEBPACK FOOTER //
// ./src/tools/mgtv/ticket.js